var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{ref:"text",tag:"component",staticClass:"text",class:{ 'border-transparent': _vm.hideCursor },style:({ borderWidth: this.cursorWidth + 'px' })},[_vm._v("​"+_vm._s(_vm.typingText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }